import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShipmentLoadItemState } from './shipment-load-item.state';
import { LoadIdView } from '../../../models';
import { Store } from '@ngxs/store';
import {
  ShipmentLoadDemurrageAndDetentionTab,
  ShipmentLoadItemSetIdentifier,
  ShipmentLoadItemSetInitial,
} from './shipment-load-item.actions';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadItemFacade {
  shipmentLoadIdentifier$: Observable<LoadIdView> = this.store.select(ShipmentLoadItemState.getShipmentLoadIdentifier);
  hasDemurrageAndDetentionTab$: Observable<boolean> = this.store.select(
    ShipmentLoadItemState.hasDemurrageAndDetentionTab,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentLoadItemState.getLoaded);

  constructor(private store: Store) {}

  setShipmentLoadIdentifier(identifier: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadItemSetIdentifier(identifier));
  }

  loadShipmentLoadDemurrageAndDetentionTab(identifier: LoadIdView): void {
    this.store.dispatch(new ShipmentLoadDemurrageAndDetentionTab(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentLoadItemSetInitial());
  }
}
